import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Md5 } from 'ts-md5/dist/md5';
import { BrandingTemplate } from '@app/origami-api/constants/branding-templates';
import { getServerConfig } from '@app/origami-api/server-config';
import { ConfigService } from '@app/origami-api/services/config.service';
import { EmittedBrowsedDocsInfo } from '@app/pages/main/pages/startup-agency-submission/components/packages-documents/submission-document-upload/submission-document-upload.component';
import { SessionService } from '@app/session/session.service';
import { GeneralFields } from '@app/services/settings/modules/general';

export type AlertType = 'success' | 'info' | 'warning' | 'error';

@Component({
  standalone: false,
  selector: 'ti-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.sass'],
})
export class AlertComponent {
  // TODO: Alerts should not be wider that the width of the main content
  private _text: string;
  public isHtmlText: boolean = false;
  private _detailsTemplateInfo: EmittedBrowsedDocsInfo;
  readonly micStrings = tiStrings.app.misc;

  @Input() closable: boolean = true;
  @Input() title: string;
  @Input() isBanner: boolean;
  @Input() set text(value: string) {
    if (value.includes(BrandingTemplate.supportEmail)) {
      const supportEmailRegexp = new RegExp(BrandingTemplate.supportEmail, 'g');
      this._text = value.replace(supportEmailRegexp, getServerConfig().supportEmail);
      this.isHtmlText = true;
    } else {
      this._text = value;
    }
  }
  get text(): string {
    return this._text;
  }

  get isMuteMaintenanceBannerEnabled(): boolean {
    const muteMaintenanceBanner =
      this.sessionService.domain.settings.general?.general?.maintenanceBanner?.getMainStoreField(
        GeneralFields.GeneralField.MuteMaintenanceBanner,
      );

    return !!+muteMaintenanceBanner?.Fieldvalue;
  }

  get isMaintenanceBannerMuted(): boolean {
    return this.sessionService.user.preferences.getMuteMaintenanceBanner();
  }

  @Input() set detailsTemplateInfo(value: EmittedBrowsedDocsInfo) {
    this._detailsTemplateInfo = value;
  }

  get detailsTemplateInfo(): EmittedBrowsedDocsInfo {
    return this._detailsTemplateInfo;
  }

  @Input() html: SafeHtml;
  @Input() type: AlertType;
  @Input() customClassName: string;
  @Output() close = new EventEmitter<'timeout' | 'close-action' | 'confirmation-action'>();

  private md5: Md5;

  constructor(
    private readonly configService: ConfigService,
    private readonly sessionService: SessionService,
  ) {
    this.md5 = new Md5();
  }

  closeAlert() {
    this.close.emit('close-action');
  }

  onConfirmationButtonClick() {
    this.close.emit('confirmation-action');
  }

  muteBanner(): void {
    this.sessionService.user.preferences.setMuteMaintenanceBanner(
      this.sessionService.currentRoomId,
      true,
      this.md5.appendStr(this.html).end(),
    );
    this.closeAlert();
  }
}
